let hasBoundScrollVar = false;

// tracks the amount of open drawers
const openDrawers = new Set<string>();
// default tray id so existing functionality remains
const defaultId = 'level-1';

const ensureScrollVar = () => {
  document.documentElement.style.setProperty(
    '--scroll-y',
    `${window.scrollY}px`
  );

  if (!hasBoundScrollVar) {
    hasBoundScrollVar = true;
    window.addEventListener(
      'scroll',
      () => {
        document.documentElement.style.setProperty(
          '--scroll-y',
          `${window.scrollY}px`
        );
      },
      { passive: true }
    );
  }
};

const getScrollYFromVar = () =>
  getComputedStyle(document.documentElement)
    .getPropertyValue('--scroll-y')
    .trim();

const applyLockOnce = (id: string) => {
  ensureScrollVar();
  const scrollYVar = getScrollYFromVar() || `${window.scrollY}px`;

  // compensate for the scrollbar width so it avoids juttering as the scrollbar appears/disappears
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth > 0 && id !== defaultId)
    document.body.style.paddingRight = `${scrollbarWidth}px`;

  const { body, documentElement: root } = document;
  body.style.position = 'fixed';
  body.style.top = `-${scrollYVar}`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';

  // If this is the default tray, we want to reserve space for the scrollbar
  if (id === defaultId) {
    root.style.scrollbarGutter = 'stable';
  }
};

const releaseLockOnce = () => {
  ensureScrollVar();
  const scrollYVar = getScrollYFromVar() || `${window.scrollY}px`;

  const { body, documentElement: root } = document;

  const y = Math.abs(parseInt(body.style.top || scrollYVar || '0', 10));

  const prevScrollBehavior = root.style.scrollBehavior;
  root.style.scrollBehavior = 'auto';

  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.paddingRight = '';

  window.scrollTo({ top: y, left: 0, behavior: 'auto' });
  root.style.scrollBehavior = prevScrollBehavior;
  root.style.scrollbarGutter = '';
};

const lock = (id: string) => {
  if (openDrawers.has(id)) return;
  const wasEmpty = openDrawers.size === 0;
  openDrawers.add(id);
  if (wasEmpty) applyLockOnce(id);
};

const unlock = (id: string) => {
  if (!openDrawers.has(id)) return;
  openDrawers.delete(id);
  if (openDrawers.size === 0) releaseLockOnce();
};

const bodyScrollLock = (isScrollLocked: boolean, id: string = defaultId) => {
  if (isScrollLocked) {
    lock(id);
  } else {
    unlock(id);
  }
};

export default bodyScrollLock;
